module.exports = __webpack_public_path__ + "static/image/default.jpg?9b093000";